export enum AuctionStatus {
  Active = 0,
  Reserved = 1,
  Sold = 2,
  Inactive = 3
}
